import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { ICON_REFRESH_ALT } from '../../../extras/icons';
import { APROBADA } from '../../../../data/audienceStates';
import Swal from 'sweetalert2';
import { C_GREEN } from '../../../extras/colors';
import JudgeIntForm from './JudgeIntForm';
import { AUDIENCIAS_AGENDAR } from '../../../../data/objects';
import Authorities from '../../../../services/AuthoritiesService';
//Función principal
const AudienceJudges = props => {
    //Tomo los props
    const { audience } = props;
    //Traigo el store
    const authUser = useSelector(state => state.auth.user);
    const authorities = useSelector(state => state.auth.authorities);
    //State local
    const [show, setShow] = useState(false);
    const [selectedJudge, setSelectedJudge] = useState(null);
    //Manejo el interviniente
    const handleReselect = judge => {
        //Confirmación
        Swal.fire({
            title: 'Seleccionar Juez Interviniente?',
            text: 'La operación agendará la audiencia y no podrá revertirse',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: C_GREEN,
            confirmButtonText: 'Continuar'
        }).then((result) => {
            if(result.value){
                //Seteo el juez
                setSelectedJudge(judge);
                //Abro la ventana
                setTimeout(() => {
                    handleOpen();
                }, 300);
            }
        })
    }
    //Manejo la apertura del diálogo
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo la ocultación
    const handleClose = () => {
        setSelectedJudge(null);
        setShow(false);
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">JUECES QUE INTERVINIERON</h6>
                </div>
                <table className="table table-hover table-sm">
                    <thead>
                        <tr className="table-light">
                            <th className="text-center">Apellido y Nombre</th>
                            <th className="text-center">Tipo/s de Audiencia</th>
                            <th className="text-center">Fecha Audiencia</th>
                            {
                                audience && audience.estado.id === APROBADA ? (
                                    authUser && authorities && Authorities.hasPermission(authorities, AUDIENCIAS_AGENDAR) ? (
                                        <th className="text-center"></th>
                                    ) : null
                                ) : null
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            audience.judges && audience.judges.length > 0 ? (
                                <React.Fragment>
                                    {
                                        audience.judges.map((judge, index) => (
                                            <tr key={`afaj${judge.id}-${index}`}>
                                                <td className="align-middle text-center">
                                                    { judge.apellido + ', ' + judge.nombre }
                                                </td>
                                                <td className="align-middle">
                                                    { judge.audienciaTipos }
                                                </td>
                                                <td className="align-middle text-center">
                                                    { judge.audienciaFecha ? moment(judge.audienciaFecha).format('DD/MM/YYYY') : '' }
                                                </td>
                                                {
                                                    audience && audience.estado.id === APROBADA ? (
                                                        authUser && authorities && Authorities.hasPermission(authorities, AUDIENCIAS_AGENDAR) ? (
                                                            <td className="align-middle">
                                                                <Button size="sm" variant="warning" onClick={() => handleReselect(judge)}>
                                                                    <ICON_REFRESH_ALT />
                                                                </Button>
                                                            </td>
                                                        ) : null
                                                    ) : null
                                                }
                                            </tr>
                                        ))
                                    }

                                    <JudgeIntForm
                                        show={show}
                                        handleClose={handleClose}
                                        audience={audience}
                                        judge={selectedJudge}
                                    />
                                </React.Fragment>
                            ) : null
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AudienceJudges;